<div class="register-container">
  <div class="register-form-container">


    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('emailAddress')" [autocomplete]="'email'" [name]="'email'" (valueChanged)="onEmailChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('password')" [autocomplete]="'new-password'" [name]="'password'" (valueChanged)="onPasswordChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('confirmPassword')" [autocomplete]="'new-password'" [name]="'password-confirm'" (valueChanged)="onConfirmPasswordChange($event)" (enterPressed)="onConfirmPasswordEnterPressed()"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [placeholder]="getString('username')" [autocomplete]="'username'" [name]="'username'" (valueChanged)="onUsernameChange($event)"></app-input-field>
    </div>

    <div class="instructions">
      {{getString('usernameInstructions')}}
    </div>

    <div class="txt-algn-cntr privacy-policy-container">
      <input type="checkbox" id="privacyPolicyCheckbox">
      {{getString('iveReadAndAgree')}}
      <a class="privacy-policy" href="https://api.cheapcharts.com/CheapCharts/API/HTML-Pages/privacy.php"
      target="_blank">{{getString('privacyPolicy')}}
      </a>
    </div>

    <div class="form-field">
      <button class="register-button blue-button" type="button" (click)="register()">{{getString('register')}}</button>
    </div>

    <div class="red-text">
      <span class="block" *ngIf="!success">{{getString('registrationFailed')}}</span>
      <span class="block" *ngIf="serverError">{{serverErrorMessage}}</span>
      <span class="block" *ngIf="emailInvalid">{{getString('invalidEmail')}}</span>
      <span class="block" *ngIf="formIncomplete">{{getString('formIsIncomplete')}}</span>
      <span class="block" *ngIf="privacyPolicyError">{{getString('privacyPolicyError')}}</span>
    </div>

  </div>
</div>
